import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-seguinte',
  templateUrl: './btn-seguinte.page.html',
  styleUrls: ['./btn-seguinte.page.scss'],
})
export class BtnSeguintePage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
